<template>
  <div class="col-12">
    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 3 -->
      <register-form
        :formStepId="2"
        :stepForm="2"
        :step="steps[2]"
        :realStep="2"

        :editFunction="editFunction"
        :editStatus="editStatus"
        :isApproved="isApproved"
        isBackend
      >
        <div class="form-group row custom-control custom-radio ml-2" style="padding-left: 12px">
          <div class="col-12">
            <input
              :disabled="editStatus !== `editing`"
              class="custom-control-input"
              id="meetingRadio1"
              type="radio"
              :value="true"
              v-model="form.online_meeting"
            />
            <label
              class="h5 custom-control-label text-engineer"
              for="meetingRadio1"
            >มีช่องทางสำหรับ Video Call/Online Meeting ในช่วง Job Fair</label
            >
          </div>
        </div>
<!--        <template v-if="form.online_meeting">-->
        <template>
          <template v-for="(range, rangeId) in form.meeting_times">
            <div
              :key="`onlineMeetingRanges ${rangeId}`"
              class="form-group custom-control custom-checkbox custom-control-solid ml-3 ml-sm-5 mb-4"
            >
              <div class="row">
                <div class="col-12">
                  <input
                    :disabled="editStatus !== `editing`"
                    class="custom-control-input"
                    :id="`date${rangeId}`"
                    :value="range"
                    type="checkbox"
                    v-model="range.checked"
                    @change="addMeeting(range.date)"
                  />
                  <label class="custom-control-label" :for="`date${rangeId}`">{{
                    getDateTh(range.date)
                    }}</label>
<!--                  <template v-if="range.checked">-->
                  <template>
                    <!-- Morning Section -->
                    <div class="row my-2">
                      <div
                        class="offset-1 col-10 d-flex align-items-center justify-content-start"
                      >
                        <div class="col-2">
                          <input
                            :disabled="editStatus !== `editing`"
                            class="custom-control-input"
                            :id="`${range.date}_morning`"
                            type="checkbox"
                            v-model="range.ranges.morning.checked"
                          />
                          <label
                            class="custom-control-label"
                            :for="`${range.date}_morning`"
                          ><i class="far fa-clock"></i> ช่วงเช้า</label
                          >
                        </div>
                        <div class="col-5 col-sm-4 mb-3 mb-sm-0 ">
                          <select
                            v-model="range.ranges.morning.start_time"
                            class="form-control round"
                            :disabled="editStatus !== `editing`"
                            :id="`${range.date}_morning_start`"
                            style="border-radius: 10rem;"
                          >
                            <option disabled value="">เลือกเวลา</option>
                            <option value="09.00">09.00</option>
                            <option value="09.30">09.30</option>
                            <option value="10.00">10.00</option>
                            <option value="10.30">10.30</option>
                            <option value="11.00">11.00</option>
                            <option value="11.30">11.30</option>
                            <option value="12.00">12.00</option>
                          </select>
                        </div>
                        <div class="">ถึง</div>
                        <div class="col-5 col-sm-4 ">
                          <select
                            v-model="range.ranges.morning.end_time"
                            :disabled="editStatus !== `editing`"
                            class="form-control round"
                            :id="`${range.date}_morning_end`"
                            style="border-radius: 10rem;"
                          >
                            <option disabled value="">เลือกเวลา</option>
                            <option value="09.30">09.30</option>
                            <option value="10.00">10.00</option>
                            <option value="10.30">10.30</option>
                            <option value="11.00">11.00</option>
                            <option value="11.30">11.30</option>
                            <option value="12.00">12.00</option>
                            <option value="12.30">12.30</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!-- Morning Meeting Link -->
                    <div class="form-group row">
                      <div class="offset-1 col-10">
                        <label
                          :for="`${range.date}_morning_inputLink`"
                          class="font-weight-normal required"
                        >Link</label
                        >
                        <input
                          v-model="range.ranges.morning.meeting_link"
                          :disabled="editStatus !== `editing`"
                          type="text"
                          class="form-control col-10 form-control-user "
                          :id="`${range.date}_morning_inputLink`"
                          placeholder="Link Meeting Room "
                          style="padding: 1.2rem 1rem;"
                        />
                        <small class="input-hint"><small class="red-color">*</small>เฉพาะ Zoom meeting และ Microsoft Team meeting เท่านั้น</small>
                      </div>
                    </div>

                    <!-- Afternoon Section -->
                    <div class="row my-2">
                      <div
                        class="offset-1 col-10 d-flex align-items-center justify-content-start"
                      >
                        <div class="col-2">
                          <input
                            :disabled="editStatus !== `editing`"
                            class="custom-control-input"
                            :id="`${range.date}_afternoon`"
                            type="checkbox"
                            v-model="range.ranges.afternoon.checked"
                          />
                          <label
                            class="custom-control-label"
                            :for="`${range.date}_afternoon`"
                          ><i class="far fa-clock"></i> ช่วงบ่าย</label
                          >
                        </div>
                        <div class="col-5 col-sm-4 mb-3 mb-sm-0 ">
                          <select
                            v-model="range.ranges.afternoon.start_time"
                            :disabled="editStatus !== `editing`"
                            class="form-control round"
                            :id="`${range.date}_afternoon_start`"
                            style="border-radius: 10rem;"
                          >
                            <option disabled value="">เลือกเวลา</option>
                            <option value="12.00">12.00</option>
                            <option value="12.30">12.30</option>
                            <option value="13.00">13.00</option>
                            <option value="13.30">13.30</option>
                            <option value="14.00">14.00</option>
                            <option value="14.30">14.30</option>
                            <option value="15.00">15.00</option>
                            <option value="15.30">15.30</option>
                          </select>
                        </div>
                        <div class="">ถึง</div>
                        <div class="col-5 col-sm-4 ">
                          <select
                            :disabled="editStatus !== `editing`"
                            v-model="range.ranges.afternoon.end_time"
                            class="form-control round"
                            :id="`${range.date}_afternoon_end`"
                            style="border-radius: 10rem;"
                          >
                            <option disabled value="">เลือกเวลา</option>
                            <option value="12.30">12.30</option>
                            <option value="13.00">13.00</option>
                            <option value="13.30">13.30</option>
                            <option value="14.00">14.00</option>
                            <option value="14.30">14.30</option>
                            <option value="15.00">15.00</option>
                            <option value="15.30">15.30</option>
                            <option value="16.00">16.00</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!-- Same morning link -->
                    <div
                      class="form-group row custom-control custom-checkbox custom-control-solid ml-3 ml-sm-5 mb-2"
                    >
                      <div class="col-12 ml-3">
                        <input
                          v-model="range.ranges.afternoon.sameLink"
                          :disabled="editStatus !== `editing`"
                          class="custom-control-input"
                          :id="`date${rangeId}_same`"
                          type="checkbox"
                          @change="
                            sameLink(range.ranges.afternoon.sameLink, rangeId)
                          "
                        />
                        <label class="custom-control-label" :for="`date${rangeId}_same`"
                        >Link เหมือนช่วงเช้า</label
                        >
                      </div>
                    </div>
                    <!-- Afternnon Meeting Link -->
                    <div class="form-group row">
                      <div class="offset-1 col-10">
                        <label
                          :for="`${range.date}_afternoon_inputLink`"
                          class="font-weight-normal required ml-3"
                        >Link</label
                        >
                        <input
                          v-model="range.ranges.afternoon.meeting_link"
                          :disabled="editStatus !== `editing`"
                          type="text"
                          class="form-control col-10 form-control-user "
                          :id="`${range.date}_afternoon_inputLink`"
                          placeholder="Link Meeting Room "
                          style="padding: 1.2rem 1rem;"
                        />
                        <small class="input-hint"><small class="red-color">*</small>เฉพาะ Zoom meeting และ Microsoft Team meeting เท่านั้น</small>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
        <div class="form-group row mt-4">
          <div class="form-group row custom-control custom-radio ml-2">
            <div class="col-12">
              <input
                :disabled="editStatus !== `editing`"
                class="custom-control-input"
                id="meetingRadio2"
                type="radio"
                :value="false"
                v-model="form.online_meeting"
              />
              <label
                class="h5 custom-control-label text-engineer"
                for="meetingRadio2"
              >ไม่มีช่องทางสำหรับ Video Call/Online Meeting ในช่วง Job Fair</label
              >
            </div>
          </div>
        </div>
      </register-form>
    </fade-transition>
    <b-modal hide-header v-model="openModal" size="lg">

      <div class="d-flex justify-content-center mt-5">
        {{contentModal}}
      </div>
<!--      <template v-if="nonFields !== []">-->
      <template>
        <ul>
          <li :key="`nonfields-${index}`" v-for="(field, index) in nonFields">
            {{field}}
          </li>
        </ul>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="openModal = false"
                      class="btn-engineer btn-user btn-block mt-0">
              <h6 class="mb-0 w-auto">ปิด</h6>
            </b-button>
          </div>
        </div>

      </template>
    </b-modal>
  </div>
</template>

<script>
  import registerForm from "@/components/forms/registerForm";
  import moment from "moment";
  import api from "@/services/api";

  moment.locale("th");

  import firebase from "firebase/app";
  import "firebase/auth";
  import {mapActions} from "vuex";

  export default {
    title: "Job Fair Faculty of Engineering - Company Meeting",
    name: "meetingForm",
    components: {
      registerForm
    },
    data() {
      return {
        form: {
          meeting_times: [],
          online_meeting: true,
        },
        steps: [
          {
            title: "ข้อมูลเบื้องต้น",
            subtitle: ""
          },
          {
            title: "ข้อมูลเกี่ยวกับ",
            subtitle: "บริษัท/ตำแหน่งที่รับ"
          },
          {
            title: "รายละเอียด Online Job Fair",
            subtitle: ""
          },
          {
            title: "บันทึกข้อมูล",
            subtitle: ""
          }
        ],
        formData: {},
        onlineMeetingRanges: [
          {
            date: "21-03-2022",
            checked: false,
            ranges: {
              morning: {
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              },
              afternoon: {
                sameLink: false,
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              }
            }
          },
          {
            date: "22-03-2022",
            checked: false,
            ranges: {
              morning: {
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              },
              afternoon: {
                sameLink: false,
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              }
            }
          }
        ],
        isEmailFormat: true,
        isPhoneFormat: true,
        isPasswordFormat: true,
        editStatus: "edit",
        isApproved: true,
        nonFields: [],
        openModal: false,
        contentModal: ""
      };
    },
    async mounted() {
      // this.getCompanyData()
      // this.matchData()

      await this.fetchData();
      if (this.form.online_meeting === false) {
        this.form.meeting_times = this.onlineMeetingRanges;
      }
    },
    methods: {
      ...mapActions(["getCompanyData", "updateCompanyDataState"]),
      getDateTh(range) {
        return moment(range, "DD-MM-YYYY")
          .format("LLLL")
          .split(" เวลา ")[0]
          .replace(2021, 2564)
          .replace(2022, 2565)
          .replace(2020, 2563);
      },
      selectedDate(range) {
        this.onlineMeetingRanges.forEach(r => {
          if (r.date === range.date) {
            r.checked = !r.checked;
          }
        });
      },
      selectedRange(range, time) {
        this.onlineMeetingRanges.forEach(r => {
          if (r.date === range.date) {
            r.ranges[time].checked = !r.ranges[time].checked;
          }
        });
      },
      sameLink(e, index) {
        if (e) {
          this.form.meeting_times[
            index
            ].ranges.afternoon.meeting_link = this.form.meeting_times[
            index
            ].ranges.morning.meeting_link;
        } else {
          this.form.meeting_times[index].ranges.afternoon.meeting_link = "";
        }
      },
      onSubmit() {
        let formData = new FormData();
        let register_form = {
          address: {
            building_road: this.form.address.building_road,
            city: this.form.address.city,
            province: this.form.address.province,
            zip_code: this.form.address.zip_code
          },
          available_job: this.form.available_job,
          contact_person: {
            email: this.form.contact_person.email,
            firstName: this.form.contact_person.firstName,
            lastName: this.form.contact_person.lastName,
            phone: this.form.contact_person.phone,
            position: this.form.contact_person.position
          },
          description: this.form.description,
          email: this.form.email,
          id: "",
          industry_group: this.form.industry_group,
          interest_faculties: this.form.interest_faculties,
          name: this.form.name,
          online_meeting: this.form.online_meeting,
          meeting_times: this.form.meeting_times,
          status: "",
          website: this.form.website
        };

        if (register_form.online_meeting === false) {
          register_form.meeting_times = this.onlineMeetingRanges
        }

        formData.append("register_form", JSON.stringify(register_form));

        firebase
          .auth()
          .currentUser.getIdToken(false)
          .then(idToken => {
            api.updateCompanyDetail(idToken, formData).then(() => {
              this.updateCompanyDataState(register_form).finally(() => {
                location.reload();
              });
            })
              .catch(err => {
                console.log(err)
                location.reload();
              });
          });
      },
      alertModal(massage) {
        this.openModal = true;
        this.contentModal = massage
      },
      saveData() {
        let available = true;
        if (available) {
          this.onSubmit()
          this.alertModal("บันทึกการแก้ไขแล้ว");
          this.editStatus = "edit";
        } else {
          this.alertModal("กรุณากรอกข้อมูลให้ครบทุกช่อง");
        }
      },
      checkStepSecond() {
        if (this.form.online_meeting) {

          let temp = 0;
          this.form.meeting_times.forEach(range => {
            if (!range.checked) {
              temp++
            }
          });
          if (temp === 2) {
            return false
          }

          temp = 0;
          this.form.meeting_times.forEach(range => {
            if (range.checked) {

              if (range.ranges.afternoon.checked) {
                if (!range.ranges.afternoon.start_time || !range.ranges.afternoon.end_time || !range.ranges.afternoon.meeting_link) {
                  return false;
                }
              }

              if (range.ranges.morning.checked) {
                if (!range.ranges.morning.start_time || !range.ranges.morning.end_time || !range.ranges.morning.meeting_link) {
                  return false;
                }
              }

              if (!range.ranges.morning.checked && !range.ranges.afternoon.checked) {
                return false;
              }

            }
          });

          return true;

        } else {
          return true
        }
      },
      editFunction() {
        if (this.editStatus === "edit") {
          this.editStatus = "editing";
        } else if (this.editStatus === "editing") {
          this.saveData()
        }
      },

      fetchData() {
        if (firebase.auth().currentUser) {
          let uid = firebase.auth().currentUser.uid;
          firebase
            .auth()
            .currentUser.getIdToken(false)
            .then(idToken => {
              api
                .getCompanyDetial(idToken, {
                  id: uid
                })
                .then(res => {
                  let companyData = {
                    data: res.data.data[0],
                    isSuccess: res.data.isSuccess,
                    token: idToken
                  };
                  this.$store.state.companyData = companyData.data;
                  this.$store.state.companyContact = companyData.data.contact_person.firstName;
                  this.$store.state.token = idToken;
                  this.getCompanyDetail = companyData;
                  this.form = companyData.data;

                  let dateCount = 0;
                  for (let i = 0; i < this.form.meeting_times.length; i++) {

                    if (this.form.meeting_times[i].date === "21-03-2022") {
                      dateCount++;
                    }
                    if (this.form.meeting_times[i].date === "22-03-2022") {
                      dateCount++;
                    }

                  }

                  if (dateCount !== 2) {
                    if (this.form.meeting_times[0].date === "21-03-2022") {
                      this.form.meeting_times.push({
                        date: "22-03-2022",
                        checked: false,
                        ranges: {
                          morning: {
                            checked: false,
                            start_time: "",
                            end_time: "",
                            meeting_link: ""
                          },
                          afternoon: {
                            sameLink: false,
                            checked: false,
                            start_time: "",
                            end_time: "",
                            meeting_link: ""
                          }
                        }
                      })
                    } else if (this.form.meeting_times[0].date === "22-03-2022") {
                      this.form.meeting_times.push({
                        date: "21-03-2022",
                        checked: false,
                        ranges: {
                          morning: {
                            checked: false,
                            start_time: "",
                            end_time: "",
                            meeting_link: ""
                          },
                          afternoon: {
                            sameLink: false,
                            checked: false,
                            start_time: "",
                            end_time: "",
                            meeting_link: ""
                          }
                        }
                      });
                    }
                  }
                  for (let i = 0; i < this.form.meeting_times.length; i++) {
                    if (this.form.meeting_times[i].date === "21-03-2022") {
                      if (this.form.meeting_times[i].checked === true) {
                        this.form.meeting_times[i].checked = true
                      } else {
                        this.form.meeting_times[i].checked = false
                      }
                    }
                    if (this.form.meeting_times[i].date === "22-03-2022") {
                      if (this.form.meeting_times[i].checked === true) {
                        this.form.meeting_times[i].checked = true
                      } else {
                        this.form.meeting_times[i].checked = false
                      }
                    }
                  }

                })
                .catch(err => {
                  console.log(err);
                });
            });
        }
      },
      addMeeting(dateSelect) {
        for (let i = 0 ; i < this.form.meeting_times.length ; i++) {
          if (this.form.meeting_times[i].date === dateSelect) {
            const range = this.onlineMeetingRanges.find(r => r.date === dateSelect)
            this.form.meeting_times[i].ranges = range.ranges
          } else {
            const range = this.onlineMeetingRanges.find(r => r.date !== dateSelect)
            if (!this.form.meeting_times[i].checked) {
              this.form.meeting_times[i].ranges = range.ranges
            }
          }
        }
      },
    }
  };
</script>

<style scoped>
  .btn-user {
    font-size: 0.8rem;
    border-radius: 10rem;
    padding: 0.75rem 1rem;
  }
  .input-hint {
    font-size: 12px;
  }
  .red-color {
    color: #cf362e;
    margin-right: 5px;
  }
</style>
